module.exports = __webpack_public_path__ + "static/media/iconEdit.97d4516d.svg";